module.exports = __webpack_public_path__ + "assets/img/social/discord-icon.36bfd0d1e3d954af212303d7250232e4.svg";